function Footer({darkBG, textColor}){
    return(
        <div className="footer mt-5" style={{backgroundColor: darkBG}}>
            <div className="footer-text-container pt-3 pb-2 text-center px-3">

                <p className="footer-text">
                    <a style={{color: textColor}} href="https://abdulwahab5547.github.io/portfolio/">Made with <span><i className="fa-solid fa-heart px-1"></i></span> by Abdul Wahab</a>
                </p>
                
            </div>
        </div>
    )
}

export default Footer; 